<template>
  <div id="addresses">
    <OrkLoader :loading="loadingAddress">
      <transition>
        <div v-if="customer" class="addresses__content">
          <SfHeading
              :level="2"
              :title="$t('Delivery address')"
              class="sf-heading--no-underline"
          />
          <div class="block">
            <div v-if="customer.addresses.length===0" class="no-address">

              <p>{{ $t('Please add a delivery address') }}.</p>
              <p class="error">
                {{ $t('No saved addresses') }}
              </p>
              <SfButton @click="toggleAddressModal"> {{ $t('add new address') }}</SfButton>
            </div>

            <div v-else class="addresses">
              <div class="intro">
                <p class="text">{{
                    $t('Please select a delivery address or ')
                  }}
                  <SfButton class="inline-btn sf-button--text color-primary" @click="toggleAddressModal">
                    {{ $t('create new one') }}
                  </SfButton>
                </p>
              </div>
              <div v-if="customer.addresses && customer.addresses.length>0" class="addresses-content">
                <UserAddress v-for="address in customer.addresses" :key="address.name" :address="address"
                             :isSelected="selectedAddress===address.name"
                             :show-address-name="false"
                             v-bind="customer.address"
                             @setAddress="setShippingAddress($event)"></UserAddress>
                <!--relais
                <UserAddress v-if="selectedRelais" :address="selectedRelais" :isRelais="true"
                             :isSelected="selectedAddress===selectedRelais.name"
                             :show-address-name="false"
                             v-bind="selectedRelais"
                             @setAddress="setRelais(selectedRelais)"></UserAddress>
                -->
              </div>

            </div>

          </div>
        </div>
      </transition>
    </OrkLoader>
    <OrkLoader :loading="loadingShipment">
      <transition>
        <div v-if="shipmentMethods" class="shipping__content">
          <SfHeading
              :level=2
              :title="$t('Delivery options')"
              class=" sf-heading--no-underline title"
          />
        </div>
      </transition>

    </OrkLoader>

    <div v-if="currentCart.shipments" class="shipments">
      <div v-for="(shipment,i) in currentCart.shipments" :key="i" class="shipment-wrapper">
        <SfHeading :level="3" :title="'Expedition ' + (i+1) +' sur ' + currentCart.shipments.length"
                   class="shipment-title"></SfHeading>
        <div class="shipment">
          <div class="products">
            <SfCollectedProduct
                v-for="shipmentItem in shipment.items"
                :key="shipmentItem.product.reference"
                :has-remove="false"
                :image="shipmentItem.product.cover.src"
                :qty="shipmentItem.quantity"
                :regular-price="$n(shipmentItem.price.taxIncluded, 'currency')"

                :stock="shipmentItem.product.offer.stockQuantity"
                :title="shipmentItem.product.name"
                class="collected-product"
                imageHeight="120px"
                imageWidth="120px"

            >
              <template #image>

                <SfImage
                    :alt="shipmentItem.product.name"
                    :src="shipmentItem.product.cover.src"
                    class="sf-collected-product__image"
                    height="120"
                    placeholder="/assets/images/placeholder.webp"
                    width="120"
                />

              </template>
              <template #input>
                <div></div>
              </template>
              <template #configuration>
                <div v-if="shipmentItem.product.configurableAttributes"
                     class="collected-product__properties">

                  <SfProperty
                      v-for="(attribute, key) in shipmentItem.product.selectedAttributes"
                      :key="key"
                      :name="attribute.label"
                      :value="attribute.value"
                      class="property"
                  />

                </div>
                <div v-else></div>
              </template>
              <template #more-actions>
                <div></div>
              </template>
              <template #remove>
                <div></div>
              </template>
              <template #price>
                <div class="price-unit">
                  <span class="label">{{ $t('Unit price ') }} : </span>
                  <SfPrice class="value"
                      :regular="$n(shipmentItem.unitPrice.regular, 'currency')"
                      :special="shipmentItem.unitPrice.discount && $n(shipmentItem.unitPrice.discount,'currency')"/>
                </div>
              </template>

              <template #actions>
                <div class="quantity">
                  <span class="label">{{ $t('Quantity') }} :</span>
                  <span class="value">{{ shipmentItem.quantity }}</span>
                </div>
                <div class="price-total">
                  <OrkPrice
                      :regular="$n(shipmentItem.price.taxIncluded, 'currency') | toCurrency"></OrkPrice>
                </div>
              </template>
            </SfCollectedProduct>
          </div>


          <div v-if="shipmentMethods && shipmentMethods.length>0" class="shippingMethods">
            <h4>{{$t('Choose a shipping method')}}</h4>
            <UserShipmentOptions
                :selectedMethods="(selectedMethods && selectedMethods[i])?selectedMethods[i]:null"
                :shipmentMethods="shipmentMethods[i]?shipmentMethods[i]:null"
                :shipmentMethodsIndex=i
                @submitSelectedShipmentMethod="setShipmentMethod"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="payment">
      <p class="virement-title"> Pour tout paiement par virement bancaire, veuillez nous contacter au numéro ci-dessous afin d’obtenir un numéro de commande et les instructions de paiement. Votre commande sera préparée et expédiée à réception de votre règlement.</p>
      <sf-button class="virement-button sf-button color-primary" link="tel:+33146020744"> +33 (01) 46 02 07 44 </sf-button>


    </div>
    <div class="checkout actions">
      <SfButton
          class='sf-button color-white'
          type='button'
          @click="goBack()"
      >
        {{ $t('Edit my shopping cart') }}
      </SfButton>

      <SfButton
          :disabled="!selectedMethods.length>0 || !isDone || loading "
          aria-disabled="true"
          class='sf-button color-primary'
          @click="submitStep"
      >
        <span v-if="loading">
        <SfLoader :class="{ loader: loading }" :loading="loading"></SfLoader>
            {{ $t('Loading') }}
        </span>
        <span v-else>
        {{ $t('Next step') }}
        </span>
      </SfButton>
    </div>
  </div>

</template>

<script>

import {SfButton, SfHeading, SfLoader, SfPrice, SfImage, SfProperty, SfCollectedProduct, SfAccordion, SfInput, SfDivider} from "@storefront-ui/vue";
import UserAddress from "@/components/UserAddress.vue";

import UserShipmentOptions from "@/components/Checkout/UserShipmentOptions";
import Api from "@/api/Api";
import OrkLoader from "@/components/Ork/OrkLoader";
import OrkPrice from "@/components/Ork/OrkPrice";
import {ShipmentMethods} from "@/models/shipment";
import icons from "@/utils/icons";
import shipmentItem from "@/components/Checkout/ShipmentItem";
import GtagEvent from "@/utils/GtagEvent";


export default {
  name: "Shipping",

  components: {
    SfAccordion,
    SfInput,
    OrkLoader,
    UserShipmentOptions,
    SfHeading,
    SfButton,
    SfLoader,
    UserAddress,
    OrkPrice,
    SfPrice,
    SfImage,
    SfProperty,
    SfDivider,
    SfCollectedProduct

  },
  data() {
    return {
      error: null,
      loadingShipment: false,
      loadingAddress: false,
      shippingAddress: null,
      shipmentMethods: null,
      isDone: false,
      selectedAddress: null,
      selectedMethods: [],
      loading: false,
      icons: icons,
      coupon: null,

    };
  },
  created() {
    this.isDone = false;
    this.$emit("isDoneShipping", false);
  },
  mounted() {
    this.isDone = false;
    this.$emit("isDoneShipping", false);
    if (this.customer && this.customer.defaultShippingAddress && this.customer.addresses?.length !== 0) {

      const defaultShippingAddress = this.customer.addresses.find(address => address.name === this.customer.defaultShippingAddress) || null;
      //check if it has a selected address
      if (!(this.currentCart && this.currentCart.shipments[0].address)) {
        if (defaultShippingAddress) {
          this.setShippingAddress(defaultShippingAddress);
        }
      } else {

        // Shopping cart has an address set
        if (this.customer.addresses.find(address => address.name === this.currentCart.shipments[0].address.name)) {
          this.selectedAddress = this.currentCart.shipments[0].address.name;

          this.currentCart.shipments.forEach((shipment, i) => {
            this.selectedMethods[i] = shipment[i]?.shipmentMethod?.id ? shipment[i].shipmentMethod.id : null;
          })

          if (defaultShippingAddress) {
            this.setShippingAddress(defaultShippingAddress);

          }
        }
      }
    }
    if(this.currentCart) {
      GtagEvent.beginCheckout(this.currentCart)
    }
  },

  computed: {

    customer: {
      get() {
        return this.$store.getters.getProfile;
      },
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      set() {

      },
    },
    currentCart: {
      get() {
        return this.$store.getters.getCart;
      },
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      set() {

      },
    },
  },
  watch: {
    customer(newCustomer, oldCustomer) {
      if (newCustomer.defaultShippingAddress !== oldCustomer.defaultShippingAddress) {
        if (newCustomer.addresses.length > 0) {
          let address = newCustomer.addresses.find(address => address.name === newCustomer.defaultShippingAddress);
          this.setShippingAddress(address);
        }
      }
    },
  },
  methods: {
    setShippingAddress(address, refreshShipmentMethods = true) {

      this.isDone = false;

      this.$emit("isDoneShipping", false);

      this.selectedAddress = address ? address.name : undefined;

      return Api.cart.setShippingAddress(address)
          .then((data) => {
            this.$store.dispatch("setCart", data);
            this.currentCart = data;

            if (refreshShipmentMethods) {
              this.getShipmentMethods();
            }
          })
          .catch((e) => {
            this.isDone = false;
            this.$emit("isDoneShipping", false);
            let error = null;
            switch (e.status) {
              case 401:
                error = this.$i18n.t("errors.cartAdresse.unauthorized");
                break;
              case 409:
                error = this.$i18n.t("errors.cartAdresse.allReadyExist");
                break;
              case 404:
                error = this.$i18n.t("errors.cartAdresse.notFound");
                break;
              case 500:
                error = this.$i18n.t("errors.server.access");
                break;
            }
            if (error) {
              this.$store.dispatch("sendNotification", {type: "danger", message: error, icon: "error"});
            }
          })
          .finally(() => {
            this.loadingAddress = false;
          });
    },
    setCoupon() {
      if (this.coupon) {
        Api.cart.setCoupons(this.coupon).then((data) => {
          this.$store.dispatch('setCart', data);
          this.$store.dispatch('sendNotification', {
            type: 'info',
            message: this.$i18n.t('coupon.add'),
            icon: icons.info
          });
        })
            .catch((e) => {
              switch (e.status) {
                case 409:
                  this.$store.dispatch('sendNotification', {
                    type: 'danger',
                    message: this.$i18n.t('coupon.add'),
                    icon: icons.error
                  });
                  break;
                case 404:
                  this.$store.dispatch('sendNotification', {
                    type: 'danger',
                    message: this.$i18n.t('coupon.not'),
                    icon: icons.error
                  });
                  break;
                default:
                  this.$store.dispatch('sendNotification', {
                    type: 'danger',
                    message: this.$i18n.t('errors.server.access'),
                    icon: icons.error
                  });
                  break
              }

            })
            .finally();
      }
    },
    removeCoupon() {
      Api.cart.removeCoupons()
          .then((data) => {
            this.$store.dispatch('setCart', data);
          })
          .catch((e) => {
            switch (e.status) {
              case 409:
                this.$store.dispatch('sendNotification', {
                  type: 'danger',
                  message: this.$i18n.t('coupon code already used'),
                  icon: icons.error
                });
                break;
              case 404:
                this.$store.dispatch('sendNotification', {
                  type: 'danger',
                  message: this.$i18n.t('coupon code not exist'),
                  icon: icons.error
                });
                break;
              default:
                break
            }
          })
          .finally();

    },
    goBack() {
      this.$router.push("/mon-panier").catch();
    },
    getShipmentMethods() {
      this.loadingShipment = true;
      this.isDone = false;
      this.$emit("isDoneShipping", false);
      Api.cart.getShipmentMethods()
          .then((data) => {
            this.shipmentMethods = [];

            if (data.length > 0) {
              data.forEach((item) => {
                this.shipmentMethods.push(item);
              });

              if (this.selectedMethods && this.selectedMethods.length > 0) {
                const currentSelectedMethods = [];

                this.selectedMethods.forEach((shipmentMethod, i) => {
                  const selectedMethod = this.shipmentMethods[i].find(method => this.selectedMethods[i] === method.id);

                  if (!selectedMethod) {
                    this.isDone = false;
                    this.$emit("isDoneShipping", false);
                  }

                  currentSelectedMethods[i] = selectedMethod?.id;
                });

                this.setShipmentMethods(currentSelectedMethods);
              }

            } else {
              this.$store.dispatch("sendNotification", {
                type: "danger",
                message: this.$i18n.t("errors.noshipment"),
                icon: icons.error,
              });
            }

          })
          .catch((e) => {
              // console.error(e)
            this.shipmentMethods = null;
            this.selectedMethods = [];
            this.isDone = false;
            this.$emit("isDoneShipping", false);
          })
          .finally(() => {
            this.loadingShipment = false;

          });
    },

    submitStep() {
      this.loading = true;
      if (this.isDone) {
        this.$emit("isDoneShipping", true);
        this.$router.push("/commande/paiement").catch();
      }
    },
    setShipmentMethod(selectedMethodWithIndex) {

      this.selectedMethods[selectedMethodWithIndex.index] = selectedMethodWithIndex.shipmentMethodId;
      this.setShipmentMethods(this.selectedMethods)
    },
    setShipmentMethods(selectedMethods) {
      this.selectedMethods = selectedMethods;

      this.isDone = false;
      const hasNull = this.selectedMethods.every(function (element) {
        return !!element;
      });

      this.$emit("isDoneShipping", false);
      if (this.selectedMethods.length === this.shipmentMethods.length && hasNull) {
        this.loading = true;
        Api.cart.setShipmentMethods(this.selectedMethods)
            .then((data) => {
              this.$store.dispatch("setCart", data);
              this.isDone = true;
              this.$emit("isDoneShipping", true);
            })
            .catch((e) => {
              this.isDone = false;
              this.$emit("isDoneShipping", false);
              let error = null;
              switch (e.status) {
                case 401:
                  error = this.$i18n.t("errors.shipmentMethod.unauthorized");
                  break;
                case 409:
                  error = this.$i18n.t("errors.shipmentMethod.allReadyExist");
                  break;
                case 404:
                  error = this.$i18n.t("errors.shipmentMethod.notFound");
                  break;
                case 500:
                  error = this.$i18n.t("errors.server.access");
                  break;
              }
              if (error) {
                this.$store.dispatch("sendNotification", {type: "danger", message: error, icon: "error"});
              }
            }).finally(() => {
          this.loading = false;

        });
      }
    },
    toggleAddressModal() {
      this.$store.dispatch("toggleAddressModal");
    },
  },
};
</script>

<style lang="scss" scoped>
.payment{
  border: 1px solid var(--_c-primary-light);
  border-radius: 2px;
  padding: var(--spacer-base);
  @include for-mobile {
    padding: var(--spacer-sm);
  }
  margin: var(--spacer-base) 0;
  box-shadow: 0 2px 6px -2px rgb(0 0 0 / 10%);
}
.virement{
  &-title{
    margin-bottom: 20px;

  }
  &-button{
    margin: auto;
    display: inline-block;
    max-width: 240px;
    min-width: 240px;
  }
}
.price-content{
  .sf-property {
    margin: var(--spacer-xs) 0;
    //text-transform: uppercase;
    --property-name-font-size: var(--font-size--lg);
    --property-name-font-weight: 400;
    align-items: baseline;
    &__name {
      color: var(--c-text)
    }
    &__name::after {
      display: none;
    }

    .sf-price {
      font-weight: 400;

      &__regular {
        font-weight: 400;
      }
    }

    &.coupon-price {
      --property-name-font-weight: var(--font-weight--bold);

      .sf-price {
        font-weight: var(--font-weight--bold);

        &__regular {
          color: var(--c-text);
          font-weight: var(--font-weight--bold)
        }
      }
    }

    &.total-price {
      margin: var(--spacer-sm) 0 var(--spacer-base);
      --property-name-font-size: 26px;
      --property-name-font-weight: var(--font-weight--bold);

      .sf-price {
        font-size: 26px;
        font-weight: 700;

        &__regular {
          font-size: 26px;
          font-weight: 700;
        }
      }
    }
  }
}

.shipment {
  border-radius: 2px;
  border: 1px solid var(--_c-lightgray);
  margin: var(--spacer-base) 0;
  display: flex;
  align-self: stretch;
  flex-wrap: wrap;

  &-title {
    margin: var(--spacer-base) 0 ;
  }

  .products{
    padding: var(--spacer-base);
    width: 100%;
    display: flex;
    flex-direction: column;

    @include for-tablet{
      width: 100%;
    }
    @include for-mobile{
      width: 100%;
    }

    ::v-deep {
      .sf-collected-product {
        margin: 0 0 var(--spacer-sm) 0;
        min-height: 120px;
        --collected-product-width: 100%;
        --collected-product-padding: var(--spacer-sm) var(--spacer-xs);
        background: var(--c-white);
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
        border-radius: 2px;

        &::after {
          display: none;
        }
        &:last-of-type{
          margin-bottom: 0;
        }

        &__main {
          margin-left: var(--spacer-xs);
        }

        &__actions {
          margin: auto 0 0 0;
          display: flex;
          justify-content: space-between;
        }

        &__title {
          font-weight: var(--font-weight--bold);
          line-height: 1.2;
          margin-bottom: 0;
          font-size: var(--font-size--base);

        }

        &__image {
          margin: auto;
          border-radius: 2px;
        }

        &__aside {
          background: var(--_c-lightgray);
          border-radius: 2px;
          flex: 0 0 80px;
          display: flex;
          align-items: center;
          --collected-product-width: 80px;
          margin: 0 var(--spacer-xs);
        }

        &__configuration {
          --collected-product-configuration-margin: var(--spacer-sm) 0 0 0;
          --collected-product-padding: var(--spacer-xs);

        }

        .collected-product__properties {
          display: flex;
          flex-wrap: wrap;


          .property {
            flex-wrap: wrap;
            text-transform: none;
            margin: 0;

            &:not(:last-of-type) {
              margin: 0;

              &::after {
                font-size: var(--font-size--sm);
                content: '|';
                margin: 0 var(--spacer-xs);
              }
            }

            &:last-of-type:not(:first-of-type) {
              margin: 0;
            }


            .sf-property__name, .sf-property__value {
              font-weight: 400;
              font-size: var(--font-size--sm);
            }

            .sf-property__name {
              font-weight: bold;

              &::after {
                content: ':';
              }

            }


          }
        }

        &__properties {
          margin: var(--spacer-xs) 0 0 0;
          display: flex;
          flex-direction: column;
          justify-content: flex-end;
          align-items: flex-start;
          flex: 2;

          &:first-child {
            margin-bottom: 8px;
          }
        }

        .quantity {
          .label{
            margin-right: 5px;
          }
        }

        .price {
          &-unit {
            display: flex;
            flex-wrap: wrap;
            font-size: var(--font-size--sm);
            font-weight: 400;

            .label {
              margin-right: 5px;
            }

            .sf-price__regular, .sf-price__special {
              font-size: var(--font-size--sm);
              font-weight: 400;
            }
          }

          &-total {
            margin: 0 var(--spacer-xs) -10px;
            display: flex;

            justify-content: space-between;
            align-items: baseline;
            flex-wrap: wrap;
            font-size: var(--font-size--lg);
            font-weight: var(--font-weight--medium);

            .label {
              margin-right: 5px;
              text-transform: uppercase;
            }

            .sf-price__regular, .sf-price__special {
              font-weight: var(--font-weight--bold);
              font-size: 26px;
            }
          }
        }

        &__actions {
          margin: auto 0 0 0;
          display: flex;
          flex-wrap: wrap;
          flex-direction: initial;
          align-items: flex-end;
        }


        &:hover {
          @include for-desktop() {
            .sf-collected-product__configuration {
              --collected-product-configuration-display: flex;
            }
            .sf-collected-product__properties {
              display: block;
            }
          }

          @include for-desktop-small() {
            .sf-collected-product__configuration {
              --collected-product-configuration-display: flex;
            }
            .sf-collected-product__properties {
              display: block;
            }
          }
        }
      }


      .sf-property {
        margin: var(--spacer-xs) 0;
        //text-transform: uppercase;
        --property-name-font-size: var(--font-size--lg);
        --property-name-font-weight: 400;
        align-items: baseline;
        &__name {
          color: var(--c-text)
        }
        &__name::after {
          display: none;
        }

        .sf-price {
          font-weight: 400;

          &__regular {
            font-weight: 400;
          }
        }

        &.coupon-price {
          --property-name-font-weight: var(--font-weight--bold);

          .sf-price {
            font-weight: var(--font-weight--bold);

            &__regular {
              color: var(--c-text);
              font-weight: var(--font-weight--bold)
            }
          }
        }

        &.total-price {
          margin: var(--spacer-sm) 0 var(--spacer-base);
          --property-name-font-size: 26px;
          --property-name-font-weight: var(--font-weight--bold);

          .sf-price {
            font-size: 26px;
            font-weight: 700;

            &__regular {
              font-size: 26px;
              font-weight: 700;
            }
          }
        }
      }
    }
  }
  .shippingMethods{
    padding: var(--spacer-base);
    background-color: var(--_c-primary-sidebar);
    flex: 1;
  }
}

.addresses {
  &-content {
    display: grid;
    gap: 20px;
    grid-template-columns:  repeat(3, minmax(0, 1fr));
    @include for-desktop-small {
      grid-template-columns:  repeat(2, minmax(0, 1fr));
    }
    @include for-tablet {
      grid-template-columns:  repeat(3, minmax(0, 1fr));
    }
    @include for-mobile {
      grid-template-columns:  repeat(1, minmax(0, 1fr));
    }
  }

  .intro {
    display: flex;
    margin: var(--spacer-sm) auto var(--spacer-base);
    justify-content: center;

    .text {
      display: inline-block;

      .inline-btn {
        padding: 0;
        background-color: transparent;
        color:var(--c-primary);
        margin-left: 0;
        display: inline-block;
        &:hover,&:focus{
          color:var(--c-primary-darken);
          text-decoration : underline;
        }
      }
    }
  }
}

.shipping__actions {
  display: flex;
  flex-wrap: wrap;
  margin-top: var(--spacer-xl);
  justify-content: space-between;
}

.shipping__actions > button.sf-button {
  display: inline-block;
  margin-bottom: var(--spacer-base);

}

/**************/
.block {
  border-radius: 2px;
  border: 1px solid var(--_c-lightgray);
  padding: var(--spacer-base);
  margin: var(--spacer-sm) 0 var(--spacer-lg);
  @include for-mobile {
    padding: var(--spacer-sm);
  }

  p {
    margin-top: 0;

    &.error {
      color: var(--c-danger);
      font-weight: bold;
    }
  }
}

.user-address {
  cursor: pointer;
}

.checkout.actions {
  margin: auto 0 0 0;
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  justify-content: space-between;
  @include for-mobile {

  }

  .sf-button {
    width: fit-content;

    white-space: nowrap;
    min-height: 32px;
    padding: var(--spacer-sm) var(--spacer-sm);
    margin: var(--spacer-xs);

    &:first-of-type:not(:last-of-type) {
      margin: var(--spacer-sm) var(--spacer-sm) var(--spacer-sm) 0;
    }

    &:last-of-type:not(:first-of-type) {
      margin: var(--spacer-sm) 0 var(--spacer-sm) var(--spacer-sm);
    }

    @include for-mobile {
      flex: 100%;
      width: 100%;
      &:first-of-type:not(:last-of-type) {
        margin: var(--spacer-sm) 0;
      }
      &:last-of-type:not(:first-of-type) {
        margin: var(--spacer-sm) 0 0;
      }
    }
  }
}
.coupon {
  border-radius: 2px;
  color: var(--c-white);
  background: var(--c-primary);
  padding: var(--spacer-sm);
  margin-bottom: var(--spacer-base);

  &-content {
    display: flex;
    flex-wrap: wrap;
    align-items: start;
    white-space: nowrap;
    margin-top: var(--spacer-xs);
  }

  .sf-button {
    &-remove {

      margin-left: 0;
      justify-content: flex-start;
      background-color: transparent;
      width: 26px;
      height: 26px
    }
  }

  &-price {
    margin-left: auto;

    .sf-price {
      &__regular {
        color: white;
      }
    }
  }

  &-code {
    margin-top: 2px;
    display: flex;
    font-weight: bold;
    width: 100%;
    align-items: center;

  }

  &-heading {
    font-size: var(--font-size--lg);
    font-weight: 700;
    text-transform: uppercase;

  }
}
.coupon-side {
  display: flex;
  flex-wrap: wrap;
  background-size: cover;
  color: var(--c-primary);
  border-radius: 2px;
  align-items: center;
  justify-content: space-between;
  margin: var(--spacer-base) 0;

  ::v-deep {
    .sf-accordion {
      width: 100%;
      padding: 0 0;
    }

    .sf-accordion-item {
      &__header {
        width: 100%;
        display: flex;
        align-items: center;
        text-align: left;
        font-size: 16px;
        font-weight: normal;
        text-transform: uppercase;
        padding: var(--spacer-xs) 0;

      }

      &__content {
        padding: var(--spacer-xs) 0;
      }

      &__chevron {
        margin-left: auto;
      }
    }
  }

  &-label {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: normal;
    text-transform: uppercase;

    .text {
      margin-bottom: var(--spacer-xs);
      line-height: 1;

    }

    .sf-icon {
      @include for-mobile {
        display: none;
      }
    }
  }

  &-form {
    width: 100%;
  }

  form {
    position: relative;
    padding: 0;
    margin: 0;

    .sf-button {
      border-radius: 0 26px 26px 0;
      position: absolute;
      right: 0;
      top: 0;
      width: 42px;
      height: 42px;
      text-transform: uppercase;
    }
  }

  ::v-deep {

    .sf-input {
      margin-bottom: 0;
      background: var(--c-white);
      border-radius: 23px;


      &__wrapper {
        margin: var(--input-margin, 0 0 0 0);
      }

      &__error-message {
        display: none;
      }
    }
  }
}
</style>
